var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGptSocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 33.4719C66 51.4349 51.2236 66 33 66C14.7764 66 0 51.4349 0 33.4719C0 23.2287 4.70709 14.7191 8.91524 10.75C14.2976 5.66808 20.9803 0.188782 33 0.188782C44.3192 0.188782 54.1668 6.37846 57.755 10.75C59.6953 13.1146 66 20.8839 66 33.4719Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 33.4719C66 51.4349 51.2236 66 33 66C14.7764 66 0 51.4349 0 33.4719C0 23.2287 4.70709 14.7191 8.91524 10.75C14.2976 5.66808 20.9803 0.188782 33 0.188782C44.3192 0.188782 54.1668 6.37846 57.755 10.75C59.6953 13.1146 66 20.8839 66 33.4719Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1306 10.6655C16.8981 6.40329 22.9559 2.30996 33 2.30996C42.3235 2.30996 50.5785 6.8007 54.706 10.6655H57.6744C54.0357 6.294 44.2486 0.188782 33 0.188782C21.0458 0.188782 14.3732 5.60847 9.00596 10.6655H12.1306Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08933 33.154C3.08933 25.0766 6.37522 17.7593 11.6921 12.4439C12.7958 11.3411 14.3279 10.7499 15.9053 10.7499H49.5453C51.0976 10.7499 52.6095 11.3262 53.7182 12.3992C59.1712 17.6897 62.9157 25.2356 62.9157 33.4719C62.9157 49.7012 49.0615 62.5425 32.7077 62.5425C16.3538 62.5425 3.08933 49.3832 3.08933 33.154Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6492 32.5777C24.6492 27.7442 28.6205 23.8297 33.5241 23.8297C38.4278 23.8297 42.399 27.7442 42.399 32.5777C42.399 37.4112 38.4278 41.3257 33.5241 41.3257C28.6205 41.3257 24.6492 37.4112 24.6492 32.5777Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5392 26.09C37.9893 26.09 41.6683 29.2991 42.3537 33.4967C42.3839 33.1937 42.4041 32.8857 42.4041 32.5777C42.4041 27.7442 38.4328 23.8297 33.5292 23.8297C28.6255 23.8297 24.6542 27.7442 24.6542 32.5777C24.6542 32.9155 24.6794 33.2483 24.7147 33.5712C25.3648 29.3388 29.064 26.09 33.5392 26.09Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9678 27.4163C45.2162 32.2349 42.6359 39.2045 36.6891 40.978C41.8951 38.1663 43.9714 32.6373 40.9678 27.4163Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 40.2676C21.4389 36.6313 22.4216 26.1098 30.848 24.1774C23.3288 27.0835 22.6132 35.8216 29.0892 40.2676Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8222 33.4719C35.8222 34.7833 34.8092 35.8464 33.5594 35.8464C32.3095 35.8464 31.2966 34.7833 31.2966 33.4719C31.2966 32.1604 32.3095 31.0974 33.5594 31.0974C34.8092 31.0974 35.8222 32.1604 35.8222 33.4719Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5594 36.1544C32.1382 36.1544 30.9841 34.9522 30.9841 33.4719C30.9841 31.9915 32.1382 30.7894 33.5594 30.7894C34.9806 30.7894 36.1347 31.9915 36.1347 33.4719C36.1347 34.9522 34.9806 36.1544 33.5594 36.1544ZM33.5594 31.4004C32.4809 31.4004 31.604 32.3293 31.604 33.4719C31.604 34.6144 32.4809 35.5434 33.5594 35.5434C34.6379 35.5434 35.5148 34.6144 35.5148 33.4719C35.5148 32.3293 34.6379 31.4004 33.5594 31.4004Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.1706 32.5777C31.1706 31.2961 32.2239 30.2529 33.5292 30.2529C34.8344 30.2529 35.8877 31.2911 35.8877 32.5777C35.8877 33.8643 34.8344 34.9026 33.5292 34.9026C32.2239 34.9026 31.1706 33.8643 31.1706 32.5777Z",
    fill: "url(#paint0_linear_6_19013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0411 49.726C35.0411 44.8925 39.0124 40.978 43.916 40.978C48.8196 40.978 52.7909 44.8925 52.7909 49.726C52.7909 54.5595 48.8196 58.474 43.916 58.474C39.0124 58.474 35.0411 54.5595 35.0411 49.726Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9311 43.2383C48.3812 43.2383 52.0602 46.4474 52.7456 50.645C52.7758 50.342 52.796 50.034 52.796 49.726C52.796 44.8925 48.8247 40.978 43.921 40.978C39.0174 40.978 35.0461 44.8925 35.0461 49.726C35.0461 50.0638 35.0713 50.3967 35.1066 50.7196C35.7567 46.4871 39.4559 43.2383 43.9311 43.2383Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3596 44.5646C55.6081 49.3832 53.0278 56.3528 47.0809 58.1263C52.2869 55.3146 54.3633 49.7856 51.3596 44.5646Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4811 57.4159C31.8308 53.7796 32.8135 43.2582 41.2399 41.3257C33.7207 44.2318 33 52.9699 39.4811 57.4159Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2141 50.6202C46.2141 51.9317 45.2011 52.9947 43.9513 52.9947C42.7014 52.9947 41.6884 51.9317 41.6884 50.6202C41.6884 49.3087 42.7014 48.2457 43.9513 48.2457C45.2011 48.2457 46.2141 49.3087 46.2141 50.6202Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9513 53.3027C42.5301 53.3027 41.376 52.1005 41.376 50.6202C41.376 49.1398 42.5301 47.9426 43.9513 47.9426C45.3725 47.9426 46.5266 49.1448 46.5266 50.6202C46.5266 52.0956 45.3725 53.3027 43.9513 53.3027ZM43.9513 48.5536C42.8728 48.5536 41.9959 49.4826 41.9959 50.6202C41.9959 51.7578 42.8728 52.6917 43.9513 52.6917C45.0298 52.6917 45.9067 51.7627 45.9067 50.6202C45.9067 49.4776 45.0298 48.5536 43.9513 48.5536Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7259 50.7245C40.7259 48.966 42.1723 47.5452 43.9513 47.5452C45.7303 47.5452 47.1767 48.9709 47.1767 50.7245C47.1767 52.4781 45.7303 53.9038 43.9513 53.9038C42.1723 53.9038 40.7259 52.4781 40.7259 50.7245Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.6266 31.6687C44.6266 26.8352 48.5979 22.9207 53.5015 22.9207C58.4052 22.9207 62.3764 26.8352 62.3764 31.6687C62.3764 36.5022 58.4052 40.4167 53.5015 40.4167C48.5979 40.4167 44.6266 36.5022 44.6266 31.6687Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 25.1859C57.9667 25.1859 61.6457 28.395 62.3311 32.5926C62.3613 32.2896 62.3815 31.9816 62.3815 31.6736C62.3815 26.8401 58.4102 22.9256 53.5066 22.9256C48.6029 22.9256 44.6316 26.8401 44.6316 31.6736C44.6316 32.0114 44.6568 32.3442 44.6921 32.6671C45.3422 28.4347 49.0414 25.1859 53.5166 25.1859Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0666 39.3635C41.4163 35.7272 42.399 25.2058 50.8254 23.2734C43.3062 26.1794 42.5855 34.9175 49.0666 39.3635Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8047 32.5628C55.8047 33.8743 54.7917 34.9374 53.5418 34.9374C52.292 34.9374 51.279 33.8743 51.279 32.5628C51.279 31.2514 52.292 30.1883 53.5418 30.1883C54.7917 30.1883 55.8047 31.2514 55.8047 32.5628Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5368 35.2453C52.1156 35.2453 50.9615 34.0432 50.9615 32.5628C50.9615 31.0825 52.1156 29.8853 53.5368 29.8853C54.958 29.8853 56.1121 31.0874 56.1121 32.5628C56.1121 34.0382 54.958 35.2453 53.5368 35.2453ZM53.5368 30.4963C52.4583 30.4963 51.5814 31.4252 51.5814 32.5628C51.5814 33.7004 52.4583 34.6343 53.5368 34.6343C54.6153 34.6343 55.4922 33.7054 55.4922 32.5628C55.4922 31.4203 54.6153 30.4963 53.5368 30.4963Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.148 31.6687C51.148 30.387 52.2013 29.3438 53.5066 29.3438C54.8118 29.3438 55.8651 30.382 55.8651 31.6687C55.8651 32.9553 54.8118 33.9935 53.5066 33.9935C52.2013 33.9935 51.148 32.9553 51.148 31.6687Z",
    fill: "url(#paint1_linear_6_19013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2976 50.7245C14.2976 45.891 18.2689 41.9765 23.1726 41.9765C28.0762 41.9765 32.0475 45.891 32.0475 50.7245C32.0475 55.558 28.0762 59.4725 23.1726 59.4725C18.2689 59.4725 14.2976 55.558 14.2976 50.7245Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1826 44.2368C27.6327 44.2368 31.3117 47.4459 31.9971 51.6435C32.0273 51.3405 32.0475 51.0325 32.0475 50.7245C32.0475 45.891 28.0762 41.9765 23.1726 41.9765C18.2689 41.9765 14.2976 45.891 14.2976 50.7245C14.2976 51.0623 14.3228 51.3951 14.3581 51.718C15.0082 47.4856 18.7074 44.2368 23.1826 44.2368Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6162 45.5631C34.8647 50.3817 32.2844 57.3513 26.3375 59.1248C31.5435 56.3131 33.6199 50.7841 30.6162 45.5631Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7376 58.4144C11.0873 54.7781 12.0701 44.2566 20.4965 42.3242C12.9772 45.2303 12.2616 53.9684 18.7376 58.4144Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4707 51.6137C25.4707 52.9252 24.4577 53.9883 23.2078 53.9883C21.958 53.9883 20.945 52.9252 20.945 51.6137C20.945 50.3023 21.958 49.2392 23.2078 49.2392C24.4577 49.2392 25.4707 50.3023 25.4707 51.6137Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2078 54.2962C21.7866 54.2962 20.6326 53.0941 20.6326 51.6187C20.6326 50.1433 21.7866 48.9362 23.2078 48.9362C24.629 48.9362 25.7831 50.1383 25.7831 51.6187C25.7831 53.099 24.629 54.2962 23.2078 54.2962ZM23.2078 49.5472C22.1293 49.5472 21.2524 50.4761 21.2524 51.6187C21.2524 52.7612 22.1293 53.6852 23.2078 53.6852C24.2863 53.6852 25.1633 52.7563 25.1633 51.6187C25.1633 50.4811 24.2863 49.5472 23.2078 49.5472Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9824 51.718C19.9824 49.9645 21.4288 48.5388 23.2078 48.5388C24.9869 48.5388 26.4333 49.9645 26.4333 51.718C26.4333 53.4716 24.9869 54.8973 23.2078 54.8973C21.4288 54.8973 19.9824 53.4716 19.9824 51.718Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.864 38.8508C23.3299 35.4344 23.3299 29.8955 19.864 26.4792C16.3982 23.0629 10.7789 23.0629 7.31301 26.4792C3.84714 29.8955 3.84714 35.4344 7.31301 38.8508C10.7789 42.2671 16.3982 42.2671 19.864 38.8508Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5971 26.1794C18.0472 26.1794 21.7262 29.3885 22.4116 33.5861C22.4418 33.2831 22.462 32.9751 22.462 32.6671C22.462 27.8336 18.4907 23.9191 13.587 23.9191C8.68341 23.9191 4.71212 27.8336 4.71212 32.6671C4.71212 33.0049 4.73732 33.3378 4.7726 33.6607C5.42272 29.4282 9.12186 26.1794 13.5971 26.1794Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0257 27.5057C25.2741 32.3243 22.6938 39.2939 16.7469 41.0674C21.953 38.2557 24.0293 32.7267 21.0257 27.5057Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14706 40.357C1.49679 36.7207 2.47953 26.1993 10.9059 24.2668C3.38668 27.1729 2.666 35.911 9.14706 40.357Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8852 33.5613C15.8852 34.8728 14.8722 35.9358 13.6223 35.9358C12.3725 35.9358 11.3595 34.8728 11.3595 33.5613C11.3595 32.2498 12.3725 31.1868 13.6223 31.1868C14.8722 31.1868 15.8852 32.2498 15.8852 33.5613Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6223 36.2438C12.2011 36.2438 11.047 35.0417 11.047 33.5613C11.047 32.081 12.2011 30.8788 13.6223 30.8788C15.0435 30.8788 16.1926 32.081 16.1926 33.5613C16.1926 35.0417 15.0385 36.2438 13.6223 36.2438ZM13.6223 31.4898C12.5438 31.4898 11.6669 32.4187 11.6669 33.5613C11.6669 34.7039 12.5438 35.6328 13.6223 35.6328C14.7008 35.6328 15.5727 34.7039 15.5727 33.5613C15.5727 32.4187 14.6958 31.4898 13.6223 31.4898Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.2285 32.6671C11.2285 31.3855 12.2818 30.3423 13.587 30.3423C14.8923 30.3423 15.9456 31.3805 15.9456 32.6671C15.9456 33.9538 14.8923 34.992 13.587 34.992C12.2818 34.992 11.2285 33.9538 11.2285 32.6671Z",
    fill: "url(#paint2_linear_6_19013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4928 18.8174C17.4928 15.3152 20.3755 12.4737 23.9285 12.4737C27.4815 12.4737 30.3642 15.3152 30.3642 18.8174C30.3642 22.3195 27.4815 25.161 23.9285 25.161C20.3755 25.161 17.4928 22.3195 17.4928 18.8174Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9386 14.113C27.164 14.113 29.8351 16.4428 30.3289 19.483C30.3541 19.2645 30.3642 19.0409 30.3642 18.8174C30.3642 15.3152 27.4815 12.4737 23.9285 12.4737C20.3755 12.4737 17.4928 15.3152 17.4928 18.8174C17.4928 19.0608 17.5079 19.3042 17.5382 19.5377C18.0119 16.4677 20.693 14.113 23.9386 14.113Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.326 15.0767C32.4053 18.569 30.5356 23.626 26.2216 24.9126C29.9963 22.8759 31.5032 18.8621 29.326 15.0767Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7081 24.396C15.1594 21.7582 15.87 14.1279 21.9832 12.7271C16.5302 14.8333 16.0111 21.172 20.7081 24.396Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5967 19.4682C25.5967 20.4219 24.8609 21.1919 23.9537 21.1919C23.0466 21.1919 22.3108 20.4219 22.3108 19.4682C22.3108 18.5144 23.0466 17.7444 23.9537 17.7444C24.8609 17.7444 25.5967 18.5144 25.5967 19.4682Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9537 21.4949C22.8752 21.4949 22.0033 20.5859 22.0033 19.4681C22.0033 18.3504 22.8752 17.4413 23.9537 17.4413C25.0322 17.4413 25.9041 18.3504 25.9041 19.4681C25.9041 20.5859 25.0322 21.4949 23.9537 21.4949ZM23.9537 18.0474C23.223 18.0474 22.6232 18.6833 22.6232 19.4632C22.6232 20.2431 23.223 20.8789 23.9537 20.8789C24.6845 20.8789 25.2842 20.2431 25.2842 19.4632C25.2842 18.6833 24.6845 18.0474 23.9537 18.0474Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.2201 18.8174C22.2201 17.8884 22.9861 17.1334 23.9285 17.1334C24.8709 17.1334 25.637 17.8884 25.637 18.8174C25.637 19.7463 24.8709 20.5014 23.9285 20.5014C22.9861 20.5014 22.2201 19.7463 22.2201 18.8174Z",
    fill: "url(#paint3_linear_6_19013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6639 18.8174C36.6639 15.3152 39.5466 12.4737 43.0996 12.4737C46.6526 12.4737 49.5353 15.3152 49.5353 18.8174C49.5353 22.3195 46.6526 25.161 43.0996 25.161C39.5466 25.161 36.6639 22.3195 36.6639 18.8174Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1096 14.113C46.3401 14.113 49.0061 16.4428 49.5 19.483C49.5252 19.2645 49.5353 19.0409 49.5353 18.8174C49.5353 15.3152 46.6526 12.4737 43.0996 12.4737C39.5466 12.4737 36.6639 15.3152 36.6639 18.8174C36.6639 19.0608 36.679 19.3042 36.7092 19.5377C37.1829 16.4677 39.8641 14.113 43.1096 14.113Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4971 15.0767C51.5764 18.569 49.7066 23.626 45.3926 24.9126C49.1674 22.8759 50.6742 18.8621 48.4971 15.0767Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8842 24.396C34.3355 21.7582 35.0461 14.1279 41.1593 12.7271C35.7063 14.8333 35.1872 21.172 39.8842 24.396Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7677 19.4682C44.7677 20.4219 44.0319 21.1919 43.1248 21.1919C42.2176 21.1919 41.4818 20.4219 41.4818 19.4682C41.4818 18.5144 42.2176 17.7444 43.1248 17.7444C44.0319 17.7444 44.7677 18.5144 44.7677 19.4682Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1248 21.4949C42.0463 21.4949 41.1744 20.5859 41.1744 19.4681C41.1744 18.3504 42.0463 17.4413 43.1248 17.4413C44.2033 17.4413 45.0751 18.3504 45.0751 19.4681C45.0751 20.5859 44.2033 21.4949 43.1248 21.4949ZM43.1248 18.0474C42.394 18.0474 41.7943 18.6833 41.7943 19.4632C41.7943 20.2431 42.394 20.8789 43.1248 20.8789C43.8555 20.8789 44.4552 20.2431 44.4552 19.4632C44.4552 18.6833 43.8555 18.0474 43.1248 18.0474Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.3911 18.8174C41.3911 17.8884 42.1571 17.1334 43.0996 17.1334C44.042 17.1334 44.808 17.8884 44.808 18.8174C44.808 19.7463 44.042 20.5014 43.0996 20.5014C42.1571 20.5014 41.3911 19.7463 41.3911 18.8174Z",
    fill: "url(#paint4_linear_6_19013)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00596 10.6655H57.6794C57.3216 10.2383 56.8983 9.79123 56.4296 9.33917H10.4473C9.95846 9.78129 9.47465 10.2234 9.00596 10.6655Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9119 9.33917C29.0741 5.00242 40.2471 4.90307 49.4294 9.22988C49.4294 9.22988 49.6512 9.27459 49.9939 9.33917H55.0084C55.6333 8.95666 54.8723 8.79273 55.0084 8.07242C50.3064 4.21753 42.137 0.188782 33 0.188782C22.9307 0.188782 16.6159 4.03373 11.6619 8.27112C11.6417 8.41022 11.6115 8.54434 11.5913 8.68344C11.556 8.95169 11.3998 9.13053 11.2587 9.33917H19.9068H19.9119Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1306 10.6655C16.8981 6.40329 22.9559 2.30996 33 2.30996C42.3235 2.30996 50.5785 6.8007 54.706 10.6655H57.6744C54.0357 6.294 44.2486 0.188782 33 0.188782C21.0458 0.188782 14.3732 5.60847 9.00596 10.6655H12.1306Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7627 8.18665C10.8001 9.00631 9.88287 9.84087 9.00596 10.6655H12.1306C12.6446 10.2085 13.1788 9.75145 13.7231 9.2994L11.7627 8.18665Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.706 10.6655H57.6744C57.0092 9.87072 56.1373 9.01629 55.0941 8.15192L53.0883 9.29447C53.6779 9.75646 54.2222 10.2135 54.706 10.6655Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1306 10.6655C17.6591 5.20611 25.4656 1.72876 33.3629 1.97715C41.2097 2.23546 49.0464 5.26572 54.706 10.6606C48.356 5.47933 40.1312 2.55339 31.8963 2.70242C24.6089 2.81171 17.6138 6.04067 12.1255 10.6606L12.1306 10.6655Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9391 8.18664C21.8522 -0.392464 32.5464 -2.07152 44.8383 2.40928C48.4971 3.77538 52.0198 5.58857 55.0084 8.07239C51.8384 5.85185 48.3106 4.1877 44.6417 2.95572C32.2541 -1.21709 22.3612 0.367585 11.9391 8.18664Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9053 10.7499C27.3152 10.3972 39.8691 10.3823 51.279 10.7201C39.8742 11.0778 27.3152 11.0828 15.9053 10.7499Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0962 12.7817C65.9798 23.482 67.0483 43.6655 54.5246 54.3161C50.5936 57.7438 45.8563 60.3021 40.7763 61.4745C45.7454 60.0239 50.3567 57.3663 54.1416 53.9038C66.2217 43.1936 65.113 23.8397 54.0962 12.7817Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19013",
    x1: 33.5292,
    y1: 34.9026,
    x2: 33.5292,
    y2: 30.2529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19013",
    x1: 53.5066,
    y1: 33.9935,
    x2: 53.5066,
    y2: 29.3488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19013",
    x1: 13.587,
    y1: 34.992,
    x2: 13.587,
    y2: 30.3423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19013",
    x1: 23.9285,
    y1: 20.5014,
    x2: 23.9285,
    y2: 17.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19013",
    x1: 43.0996,
    y1: 20.5014,
    x2: 43.0996,
    y2: 17.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptSocket);
export default __webpack_public_path__ + "static/media/gpt_socket.d9a82de901d8359c4df5605e7f2baad9.svg";
export { ForwardRef as ReactComponent };